import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Trophy } from "lucide-react";

interface Verdict {
  label: string;
  recommendation: string;
}

interface VerdictBoxProps {
  // Support array format
  verdicts?: Verdict[];
  // Support original format
  winner?: string;
  bestFor?: string[];
  summary?: string;
}

export const VerdictBox = ({ verdicts, winner, bestFor, summary }: VerdictBoxProps) => {
  // If verdicts array is provided, use new format
  if (verdicts && verdicts.length > 0) {
    return (
      <Card className="border-2 border-primary bg-primary/5 mb-12">
        <CardHeader className="pb-2">
          <div className="flex items-center gap-2">
            <Trophy className="h-6 w-6 text-primary" />
            <CardTitle className="text-xl">Quick Verdict</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-3">
          {verdicts.map((verdict, index) => (
            <div key={index} className="flex items-start gap-3">
              <span className="font-semibold text-primary min-w-[140px]">{verdict.label}:</span>
              <span className="text-muted-foreground">{verdict.recommendation}</span>
            </div>
          ))}
        </CardContent>
      </Card>
    );
  }

  // Original format with winner/bestFor/summary
  return (
    <Card className="border-2 border-primary bg-primary/5">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <Trophy className="h-6 w-6 text-primary" />
          <CardTitle className="text-xl">Quick Verdict</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {winner && (
          <div>
            <p className="text-lg font-semibold">
              Winner: <span className="text-primary">{winner}</span>
            </p>
          </div>
        )}
        {bestFor && bestFor.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {bestFor.map((item, index) => (
              <Badge key={index} variant="secondary">{item}</Badge>
            ))}
          </div>
        )}
        {summary && <p className="text-muted-foreground">{summary}</p>}
      </CardContent>
    </Card>
  );
};
